import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import invariant from 'invariant';
import _ from 'lodash';

import { getUserEmail } from 'reducers/selectors/user';
import {getDetailError} from '../../MusicDetailPage/selectors'
import { getCookie, setCookie, removeCookie } from 'redux-utils/reduxCookie';

import { LOAD_SESSION, SESSION_COOKIE_CONFIG, LOGOUT } from '../constants';
import {
  pendingLoadSession,
  sessionLoaded,
  sessionLoadingError,
  
} from '../actions';
import middleware, { getSession, updateDefaults } from '../service';

function setAuthToken(token) {
  updateDefaults(middleware, { params: { cm_access_token: token } });
}

export function* fetchSession() {
  const errors = yield select(getDetailError);
  yield put(pendingLoadSession());

  if(errors){
    yield alert('load session');
    const { name: cookieName, options: cookieOptions } = SESSION_COOKIE_CONFIG;

    try {
      const mail = yield select(getUserEmail);
      const response = yield call(getSession, { mail });

    const error = _.get(response, ['data', 'error'], false);
    invariant(!error, '(Music/saga...) fetchSession: Service Error');

    const session = _.get(response, ['data', 'response']);
    const token = _.get(session, 'cm_access_token', '');
    setAuthToken(token);
    yield all([
      put(sessionLoaded(session)),
      put(setCookie(cookieName, session, cookieOptions)),
    ]);
    } catch (error) {
      
    }
  }

  try {
    // retrieve the cookie and parsed
    const { name: cookieName, options: cookieOptions } = SESSION_COOKIE_CONFIG;
    let persistedSession = yield put(getCookie(cookieName));
    try {

      persistedSession = JSON.parse(persistedSession);
    } catch (error) {}

    if (!_.isEmpty(persistedSession)) {

      const token = _.get(persistedSession, 'cm_access_token', '');
    
      setAuthToken(token);
      yield put(sessionLoaded(persistedSession));
      return;
    }


    const mail = yield select(getUserEmail);
    const response = yield call(getSession, { mail });


    const error = _.get(response, ['data', 'error'], false);
    invariant(!error, '(Music/saga...) fetchSession: Service Error');

    const session = _.get(response, ['data', 'response']);
    const token = _.get(session, 'cm_access_token', '');
    setAuthToken(token);
    yield all([
      put(sessionLoaded(session)),
      put(setCookie(cookieName, session, cookieOptions)),
    ]);
  } catch (error) {
    yield alert(`error123 ${error}`);
    yield put(sessionLoadingError(error));
  }
}





export function* signOut() {
  const { name: cookieName, options: cookieOptions } = SESSION_COOKIE_CONFIG;
  yield put(removeCookie(cookieName, cookieOptions));

}



export default function* sessionSaga() {
  yield takeLatest(LOAD_SESSION.ACTION, fetchSession);
  yield takeLatest(LOGOUT.ACTION, signOut);
}
